import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { InlineAlert } from '../../../core-components/theme/components/InlineAlert';
import { emptyRegionSx } from '../../../core-components/theme/components/Screen';
import type { TimedRefusalCode } from '../domain/refusal';
import { useDeadlinePassed } from '../hooks/code/useDeadlinePassed';

import { holdLapsedText, holdText } from './codeText';

export interface HeldNotice {
  readonly reason: TimedRefusalCode;
  readonly seconds: number;
  readonly until: number;
}

export interface HoldNoticeProps {
  readonly hold: HeldNotice | null;
  readonly extra?: string | null;
}

const LiveHoldNotice: React.FC<{ readonly hold: HeldNotice; readonly extra: string | null }> = ({ hold, extra }) => {
  const { t } = useTranslation();
  const passed = useDeadlinePassed(hold.until);
  return (
    <>
      {!passed && (
        <InlineAlert severity={hold.reason === 'RESEND_TOO_SOON' ? 'info' : 'error'} role="alert" message={holdText(t, hold.reason, hold.seconds)}>
          {extra !== null && (
            <Typography variant="label" component="p">
              {extra}
            </Typography>
          )}
        </InlineAlert>
      )}
      <Box role="status" sx={emptyRegionSx}>
        {passed && <InlineAlert severity="info" message={holdLapsedText(t)} />}
      </Box>
    </>
  );
};

export const HoldNotice: React.FC<HoldNoticeProps> = ({ hold, extra = null }) => {
  if (hold === null) return null;
  return <LiveHoldNotice key={hold.until} hold={hold} extra={extra} />;
};
